import css from 'styled-jsx/css';

const styles = css.global`.desktop {
    display: none;
}

#banco-do-auto-pesado-desktop .pesado-title {
    color: #444;
    font-family: "SantanderHeadline";
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px;
    max-width: 250px;
    margin: 0;
}

#banco-do-auto-pesado-desktop.desktop .pesado-title b {
    color: #C00;
    font-weight: 800;
}

#banco-do-auto-pesado-desktop .pesado-paragrafo {
    color: #444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    margin-bottom: 32px;
    margin-top: 16px;
    max-width: 480px;
}

#banco-do-auto-pesado-desktop .pesado-paragrafo b {
    font-weight: 600;
}

#banco-do-auto-pesado-desktop .btn-banco-do-auto-pesado {
    width: 268px;
    height: 48px;
    margin-bottom: 48px;
}

#banco-do-auto-pesado-desktop .banco-do-auto-imagem {
    width: 100%;
    max-width: 350px;
    margin-top: 48px;
    margin-bottom: 16px;
}

#banco-do-auto-pesado-desktop .container-pesado {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
}

@media(min-width: 992px) {
    #banco-do-auto-pesado-desktop .pesado-title {
        max-width: unset;
        font-size: 34px;
    }

    #banco-do-auto-pesado-desktop {
        height: 409px;
        display: flex;
    }

    #banco-do-auto-pesado-desktop .container-pesado {
        flex-direction: row;
    }

    #banco-do-auto-pesado-desktop .link-banco-do-auto-pesado {
        color: #C00;
        font-family: "SantanderText";
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px;
        text-decoration: underline;
    }
}`;

export default styles;